import {
  GET_ADMIN_INTERNAL_USERS,
  GET_ADMIN_INTERNAL_USERS_SUCCESS,
  GET_ADMIN_INTERNAL_USERS_ERROR,
  GET_ALL_ADMIN_EMPLOYEES,
  GET_ALL_ADMIN_EMPLOYEES_SUCCESS,
  GET_ALL_ADMIN_EMPLOYEES_ERROR,
  CREATE_ADMIN_INTERNAL_USER,
  CREATE_ADMIN_INTERNAL_USER_SUCCESS,
  CREATE_ADMIN_INTERNAL_USER_ERROR,
  MODIFY_ADMIN_INTERNAL_USER,
  MODIFY_ADMIN_INTERNAL_USER_SUCCESS,
  MODIFY_ADMIN_INTERNAL_USER_ERROR,
  DELETE_ADMIN_INTERNAL_USER,
  DELETE_ADMIN_INTERNAL_USER_SUCCESS,
  DELETE_ADMIN_INTERNAL_USER_ERROR,
  CREATE_BULK_ADMIN_INTERNAL_USER,
  CREATE_BULK_ADMIN_INTERNAL_USER_ERROR,
  CREATE_BULK_ADMIN_INTERNAL_USER_SUCCESS,
  RESET_INVITE_SENT_TO,
  RESEND_ADMIN_INTERNAL_USER_INVITE,
  RESEND_ADMIN_INTERNAL_USER_INVITE_SUCCESS,
  RESEND_ADMIN_INTERNAL_USER_INVITE_ERROR,
  MODIFY_BULK_ADMIN_INTERNAL_USER,
  MODIFY_BULK_ADMIN_INTERNAL_USER_SUCCESS,
  MODIFY_BULK_ADMIN_INTERNAL_USER_ERROR,
  DELETE_BULK_ADMIN_INTERNAL_USER,
  DELETE_BULK_ADMIN_INTERNAL_USER_SUCCESS,
  DELETE_BULK_ADMIN_INTERNAL_USER_ERROR,
  BULK_EDIT_ADMIN_INTERNAL_USERS,
  BULK_EDIT_ADMIN_INTERNAL_USERS_SUCCESS,
  BULK_EDIT_ADMIN_INTERNAL_USERS_ERROR,
  GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS,
  GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_SUCCESS,
  GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_ERROR,
  PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT,
  PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_SUCCESS,
  PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_ERROR,
  RESET_ADMIN_INTERNAL_USERS_BULK_EDIT_PREVIEW,
} from "./actionTypes";

const initialState = {
  error: null,
  admin_manage_employees: [],
  all_admin_employees: [],
  all_admin_employees_loading: false,
  all_admin_employees_error: null,
  loading: false,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  invite_sent_to: null,
  bulk_edit_job: null,
  bulk_edit_loading: false,
  bulk_edit_status_loading: false,
  bulk_edit_error: null,
  bulk_edit_preview: { loading: false, count: null, lockHeld: false, error: null },
}

const AdminManageInternalUsers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_INTERNAL_USERS:
      return {
        ...state,
        loading: true,
        admin_manage_employees: state.admin_manage_employees,
        last_page_fetched: state.last_page_fetched,
      }

    case GET_ADMIN_INTERNAL_USERS_SUCCESS:
      return {
        ...state,
        admin_manage_employees: action.payload.data || [],
        last_page_fetched: parseInt(action.payload.additional_data?.page_number),
        total_number_of_pages: parseInt(action.payload.additional_data?.total_number_of_pages),
        loading: false
      }

    case GET_ADMIN_INTERNAL_USERS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_ALL_ADMIN_EMPLOYEES:
      return {
        ...state,
        all_admin_employees_loading : true
      }

    case GET_ALL_ADMIN_EMPLOYEES_SUCCESS:
      return {
        ...state,
        all_admin_employees: action.payload,
        all_admin_employees_loading: false
      }

    case GET_ALL_ADMIN_EMPLOYEES_ERROR:
      return {
        ...state,
        all_admin_employees_error: action.payload,
        all_admin_employees_loading: false
      }

    case CREATE_ADMIN_INTERNAL_USER:
      return {
        ...state,
        loading: true
      }

    case CREATE_ADMIN_INTERNAL_USER_SUCCESS:
      return {
        ...state,
        admin_manage_employees: [...state.admin_manage_employees, action.payload],
        loading: false
      }

    case CREATE_ADMIN_INTERNAL_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case CREATE_BULK_ADMIN_INTERNAL_USER:
      return {
        ...state,
        loading: true
      }

    case CREATE_BULK_ADMIN_INTERNAL_USER_SUCCESS:
      return {
        ...state,
        admin_manage_employees: [...state.admin_manage_employees, ...action.payload],
        loading: false
      }

    case CREATE_BULK_ADMIN_INTERNAL_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case MODIFY_ADMIN_INTERNAL_USER:
      return {
        ...state,
        loading: true
      }

    case MODIFY_ADMIN_INTERNAL_USER_SUCCESS:
      return {
        ...state,
        admin_manage_employees: state.admin_manage_employees.map((manage_employees) => (manage_employees.id == action.payload.id
          ? { manage_employees, ...action.payload }
          : manage_employees)),
        all_admin_employees: state.all_admin_employees.map((admin_employee) => (admin_employee.id == action.payload.id) ?
          { admin_employee, ...action.payload } : admin_employee),
        loading: false
      }

    case MODIFY_ADMIN_INTERNAL_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case MODIFY_BULK_ADMIN_INTERNAL_USER:
      return {
        ...state,
        loading: true
      }

    case MODIFY_BULK_ADMIN_INTERNAL_USER_SUCCESS:
    case DELETE_BULK_ADMIN_INTERNAL_USER_SUCCESS:
    // admin_manage_employees: state.admin_manage_employees.filter(ame => ame.id != action.payload.id),
    // Since we're showing deleted users on the page, delete user success is the same as modify
      return {
        ...state,
        admin_manage_employees: state.admin_manage_employees.map((manage_employees) => (manage_employees.id == action.payload.id
          ? { manage_employees, ...action.payload }
          : manage_employees)),
        admin_manage_employees: state.admin_manage_employees.map(employee => {
          const same_employee_in_payload = action.payload.find(payload_employee => payload_employee.id === employee.id);
          if (same_employee_in_payload) {
            return same_employee_in_payload;
          }

          return employee;
        }),
        loading: false
      }

    case MODIFY_BULK_ADMIN_INTERNAL_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_ADMIN_INTERNAL_USER:
      return {
        ...state,
        loading: true
      }

    case DELETE_ADMIN_INTERNAL_USER_SUCCESS:
      return {
        ...state,
        admin_manage_employees:  state.admin_manage_employees.map((manage_employees) => (manage_employees.id == action.payload.id
          ? { manage_employees, ...action.payload }
          : manage_employees)),
        loading: false
      }

    case DELETE_ADMIN_INTERNAL_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_BULK_ADMIN_INTERNAL_USER:
      return {
        ...state,
        loading: true
      }

    case DELETE_BULK_ADMIN_INTERNAL_USER_SUCCESS:
      return {
        ...state,
        loading: false
      }

    case DELETE_BULK_ADMIN_INTERNAL_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case RESEND_ADMIN_INTERNAL_USER_INVITE:
      return {
        ...state
      }

    case RESEND_ADMIN_INTERNAL_USER_INVITE_SUCCESS:
      return {
        ...state,
        invite_sent_to: action.payload
      }

    case RESEND_ADMIN_INTERNAL_USER_INVITE_ERROR:
      return {
        ...state,
        error: action.payload
      }

    case RESET_INVITE_SENT_TO:
      return {
        ...state,
        invite_sent_to: null
      }

    case BULK_EDIT_ADMIN_INTERNAL_USERS:
      return { ...state, bulk_edit_error: null, bulk_edit_loading: true }

    case BULK_EDIT_ADMIN_INTERNAL_USERS_SUCCESS:
      return { ...state, bulk_edit_job: action.payload, bulk_edit_loading: false }

    case BULK_EDIT_ADMIN_INTERNAL_USERS_ERROR:
      return { ...state, bulk_edit_error: action.payload, bulk_edit_loading: false }

    case GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS:
      return { ...state, bulk_edit_status_loading: true }

    case GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_SUCCESS:
      return { ...state, bulk_edit_job: action.payload || null, bulk_edit_status_loading: false }

    // A failed status check must not look like a failed submit (that toast
    // is driven by bulk_edit_error), so it only clears the loading flag.
    case GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_ERROR:
      return { ...state, bulk_edit_status_loading: false }

    case PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT:
      return {
        ...state,
        bulk_edit_preview: { loading: true, count: null, lockHeld: false, error: null },
      }

    case PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_SUCCESS:
      return {
        ...state,
        bulk_edit_preview: {
          loading: false,
          count: typeof action.payload?.count === "number" ? action.payload.count : null,
          lockHeld: Boolean(action.payload?.lock_held),
          error: null,
        },
      }

    case PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_ERROR:
      return {
        ...state,
        bulk_edit_preview: { loading: false, count: null, lockHeld: false, error: action.payload },
      }

    case RESET_ADMIN_INTERNAL_USERS_BULK_EDIT_PREVIEW:
      return { ...state, bulk_edit_preview: initialState.bulk_edit_preview }

    default:
      return state
  }
}

export default AdminManageInternalUsers;
